import "./Episode.css";

import * as moment from "moment";

import { Col, Grid, Row } from "react-bootstrap";

import Avatar from "react-avatar";
import Constants from "../../../../Phi/Constants";
import HSGCard from "../../../../Components/HSGCard/HSGCard";
import React from "react";
import avatarBoy from "../../../../Assets/avatar-child-boy.png";
import avatarGirl from "../../../../Assets/avatar-child-girl.png";
import history from '../../../../history';

const DATE_OPTIONS = {
    weekday: "short",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "numeric"
};

const SMALL_SWITCH = 995;

class EpisodeCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0
        };
    }

    componentWillMount() {}

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    getValueInputDivision = (className, label, input, defaultInput) =>
        input || defaultInput ? (
            <div className={className}>
                <label className="hsg-sv-label">{label}</label>
                <label className="hsg-sv-input">{`${input ? input : defaultInput}`}</label>
            </div>
        ) : null;

    getDivision = (className, input) => <div className={className}>{input}</div>;

    getHeadContentDivision = (className, head, content, defaultInput) =>
        content ? (
            <div className={className}>
                <label className="episode-block-head col-xs-12 col-sm-12 col-md-12 col-lg-12">{head}</label>
                <label className="episode-block-content col-xs-12 col-sm-12 col-md-12 col-lg-12">{`${
                    content ? content : defaultInput
                }`}</label>
            </div>
        ) : null;

    _renderStudentBasicInfo = student => {
        let studentClass = student.class ? student.class + (student.section ? " | " + student.section : "") : "NA";

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className="hsg-sv-label">{"Basic Info"}</label>
                    <label
                        className="hsg-sv-label right"
                        style={{ color: "#a0c2ff", cursor: "pointer" }}
                        onClick={() => this.props.openStudentProfile(student.student_id)}
                    >
                        {"View Profile"}
                    </label>
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", "Class: ", studentClass, "NA")}
                    {/* {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", "HSG Id: ", student.uuid, "NA")} */}
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", "Gender: ", student.gender, "NA")}
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", "DOB: ", moment(student.dob).format(Constants.defaultDateFormat), "NA")}
                    {this.getValueInputDivision(
                        "row col-md-3 col-sm-12 col-xs-12",
                        "Admission Number: ",
                        student.admission_number,
                        "NA"
                    )}
                </div>
            </div>
        );
    };

    _renderStudentParentInfo = parent => {
        let parentName = parent && parent.parent_name ? parent.parent_name.trim().toUpperCase() : "NA";

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className="hsg-sv-label">{"Parent Info"}</label>
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">
                    {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", "Name: ", parentName, "NA")}
                    {this.getValueInputDivision("row col-md-4 col-sm-12 col-xs-12", "Email: ", parent.user_email, "NA")}
                    {this.getValueInputDivision(
                        "row col-md-4 col-sm-12 col-xs-12",
                        "Contact: ",
                        parent.user_phone_number,
                        "NA"
                    )}
                </div>
            </div>
        );
    };

    formatEpisodeStrings = string =>
        // string ? string.trim().slice(0,-1).toUpperCase() : null
        string ? string.trim().toUpperCase() : null;

    _renderStudentEpisodeInfo = (episode, props) => {
        let contactInfo = episode.med_called_ambulance ? `Connected with Ambulance` : null;
        contactInfo = episode.med_called_parents
            ? contactInfo
                ? contactInfo + " and Parent"
                : "Connected with Parent"
            : null;
        contactInfo = contactInfo ? contactInfo + " During this Episode." : null;

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">
                {!!props.enableEpisodeIdLabelBody && (
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <label className="hsg-sv-label">{"Episode Info"}</label>
                    </div>
                )}
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">
                    {!!props.enableEpisodeIdInBody &&
                        this.getValueInputDivision(
                            "row col-md-12 col-sm-12 col-xs-12",
                            "Episode Id: ",
                            episode.med_episode_id,
                            null
                        )}
                    {this.getValueInputDivision(
                        "row col-md-12 col-sm-12 col-xs-12",
                        "Complaints: ",
                        this.formatEpisodeStrings(episode.med_complaint),
                        null
                    )}
                    {this.getValueInputDivision(
                        "row col-md-12 col-sm-12 col-xs-12",
                        "Sign/Symptom: ",
                        this.formatEpisodeStrings(episode.med_symptoms),
                        null
                    )}
                    {this.getValueInputDivision(
                        "row col-md-12 col-sm-12 col-xs-12",
                        "Treatment/Suggestions: ",
                        this.formatEpisodeStrings(episode.med_suggestion),
                        null
                    )}
                    {this.getValueInputDivision(
                        "row col-md-12 col-sm-12 col-xs-12",
                        "Remark: ",
                        (episode.med_remark && episode.med_remark.toUpperCase()) || null,
                        null
                    )}
                    {this.getValueInputDivision("row col-md-12 col-sm-12 col-xs-12", "Info: ", contactInfo, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", "Height: ", episode.med_height, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", "Weight: ", episode.med_weight, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", "Dia: ", episode.med_bp_dia, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", "Sys: ", episode.med_bp_sys, null)}
                    {this.getValueInputDivision(
                        "row col-md-2 col-sm-6 col-xs-6",
                        "Resp: ",
                        episode.med_respiratory_rate,
                        null
                    )}
                    {this.getValueInputDivision(
                        "row col-md-2 col-sm-6 col-xs-6",
                        "Body Temp: ",
                        episode.med_body_temp,
                        null
                    )}
                    {this.getValueInputDivision(
                        "row col-md-2 col-sm-6 col-xs-6",
                        "Heart Rate: ",
                        episode.med_heart_rate,
                        null
                    )}
                </div>
            </div>
        );
    };

    trimFloat(value) {
        return Number(parseFloat(Math.round(parseFloat(value * 100).toFixed(3)) / 100).toFixed(2));
    }

    calculateBmi(height, weight) {
        height = parseFloat(height) / 100;
        weight = parseFloat(weight);

        const bmi = weight / (height * height);

        return this.trimFloat(bmi);
    }

    getEpisodeTypeHead = head => (
        <div className="row hsg-episode-type-head-v1-small col-xs-12 col-sm-12 col-md-12 col-lg-12">{head}</div>
    );

    _renderStudentEpisodeInfoV2 = (episode, props, type, index) => {
        let headContentOneCSS =
            "remove-default-col-padding head-content-division col-xs-12 col-sm-12 col-md-12 col-lg-12";
        let headContentTwoCSS = "remove-default-col-padding head-content-division col-xs-6 col-sm-6 col-md-6 col-lg-6";
        let headContentThreeCSS =
            "remove-default-col-padding head-content-division col-xs-4 col-sm-4 col-md-4 col-lg-4";

        let contactInfo = episode.med_called_ambulance ? `Connected with Ambulance` : null;
        contactInfo = episode.med_called_parents
            ? contactInfo
                ? contactInfo + " and Parent"
                : "Connected with Parent"
            : null;
        contactInfo = contactInfo ? contactInfo + " During this Episode." : null;

        // Hidden ??
        let flag = type === 1 && props.hideFullEpisode ? true : false;
        let bmi = this.calculateBmi(episode.med_height, episode.med_weight);

        let episodeMainCSS = flag ? headContentTwoCSS : headContentOneCSS;

        return (
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" key={index}>
                {type === Constants.episodeIdMap.EPISODE && this.getEpisodeTypeHead("EPISODE")}
                {this.getHeadContentDivision(episodeMainCSS, "Complaints:", episode.med_complaint, null)}
                {this.getHeadContentDivision(episodeMainCSS, "Sign/Symptom:", episode.med_symptoms, null)}

                <div className="col-xs-12" />
                {this.getHeadContentDivision(episodeMainCSS, "Treatment/Suggestions:", episode.med_suggestion, null)}
                {this.getHeadContentDivision(episodeMainCSS, "Remark:", episode.med_remark, null)}

                <div className="col-xs-12" />
                {this.getHeadContentDivision(headContentOneCSS, "Contact Info:", contactInfo, null)}

                <div className="col-xs-12" />
                {type === Constants.episodeIdMap.ANTHROPOMETRIC && this.getEpisodeTypeHead("GROWTH")}
                {this.getHeadContentDivision(headContentThreeCSS, "Height:", episode.med_height, null)}
                {this.getHeadContentDivision(headContentThreeCSS, "Weight:", episode.med_weight, null)}
                {this.getHeadContentDivision(headContentThreeCSS, "BMI:", bmi, null)}

                <div className="col-xs-12" />
                {type === Constants.episodeIdMap.VITALS && this.getEpisodeTypeHead("VITALS")}
                {this.getHeadContentDivision(headContentThreeCSS, "Systolic:", episode.med_bp_sys, null)}
                {this.getHeadContentDivision(headContentThreeCSS, "Diastolic:", episode.med_bp_dia, null)}
                                {Boolean(episode.med_body_temp) && this.getHeadContentDivision(headContentThreeCSS, "Body Temperature:", episode.med_body_temp + (Boolean(episode.med_body_temp_unit) ? episode.med_body_temp_unit : ''), null)}

                <div className="col-xs-12" />
                {this.getHeadContentDivision(
                    headContentThreeCSS,
                    "Respiratory rates:",
                    episode.med_respiratory_rate,
                    null
                )}
                {this.getHeadContentDivision(headContentThreeCSS, "Heart rate:", episode.med_heart_rate, null)}
                {Boolean(episode.med_spo2) && this.getHeadContentDivision(headContentThreeCSS, "SPO2:", episode.med_spo2, null)}

                <div className="col-xs-12" />
                {type === Constants.episodeIdMap.EYE && this.getEpisodeTypeHead("OPTOMETRY")}
                {this.getHeadContentDivision(
                    headContentTwoCSS,
                    "Left(Without Spectacles):",
                    episode.optometryLeft,
                    null
                )}
                {this.getHeadContentDivision(
                    headContentTwoCSS,
                    "Right(Without Spectacles):",
                    episode.optometryRight,
                    null
                )}

                <div className="col-xs-12" />
                {this.getHeadContentDivision(
                    headContentTwoCSS,
                    "Left(With Spectacles):",
                    episode.optometryLeftSpectacles,
                    null
                )}
                {this.getHeadContentDivision(
                    headContentTwoCSS,
                    "Right(With Spectacles):",
                    episode.optometryRightSpectacles,
                    null
                )}

                {
                    // !!!flag ? (
                    //     <div>
                    //         {this.getHeadContentDivision(headContentThreeCSS, "Height:", episode.med_height, null)}
                    //         {this.getHeadContentDivision(headContentThreeCSS, "Weight:", episode.med_weight, null)}
                    //         {this.getHeadContentDivision(headContentThreeCSS, "BMI:", "24.8 (Overweight HardCoded Value)", null)}
                    //         {this.getHeadContentDivision(headContentThreeCSS, "Diastolic:", episode.med_bp_dia, null)}
                    //         {this.getHeadContentDivision(headContentThreeCSS, "Systolic:", episode.med_bp_sys, null)}
                    //         {this.getHeadContentDivision(headContentThreeCSS, "Body Temprature:", episode.med_body_temp, null)}
                    //         {this.getHeadContentDivision(
                    //             headContentThreeCSS,
                    //             "Respiratory rate:",
                    //             episode.med_respiratory_rate,
                    //             null
                    //         )}
                    //         {this.getHeadContentDivision(headContentThreeCSS, "Heart rate:", episode.med_heart_rate, null)}
                    //     </div>
                    // ) : (
                    //     <div className = "col-xs-12 col-sm-12 col-md-12 col-lg-12" style = {{marginBottom: 10}}>
                    //         {/* <div className = "col-xs-4 col-sm-4 col-md-4 col-lg-4 hsg-dashboard-avatar-container">
                    //             <div className="hsg-dashboard-avatar-image-episode flot-in-center">
                    //                 <span className="glyphicon glyphicon-resize-vertical episode" style={{color: "black"}}></span>
                    //             </div>
                    //         </div>
                    //         <div className = "col-xs-4 col-sm-4 col-md-4 col-lg-4 hsg-dashboard-avatar-container">
                    //             <div className="hsg-dashboard-avatar-image-episode flot-in-center">
                    //                 <span className="glyphicon glyphicon-search" style={{color: "black"}}></span>
                    //             </div>
                    //         </div>
                    //         <div className = "col-xs-4 col-sm-4 col-md-4 col-lg-4 hsg-dashboard-avatar-container">
                    //             <div className="hsg-dashboard-avatar-image-episode flot-in-center">
                    //                 <span className="glyphicon glyphicon-globe" style={{color: "green"}}></span>
                    //             </div>
                    //         </div> */}
                    //     </div>
                    // )
                }

                {props.showEpisodeId &&
                    this.getDivision(
                        "episode-id col-xs-12 col-sm-12 col-md-12 col-lg-12 on-right",
                        episode.med_episode_id ? `Episode ID: ${episode.med_episode_id}` : null
                    )}
            </div>
        );
    };

    getDaysPassed = millis => {
        let seconds = Math.floor(millis / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);
        let months = Math.floor(days / 30);
        let years = Math.floor(months / 12);

        return `${
            years
                ? `${years} ${years > 1 ? "Years" : "Year"}`
                : months
                ? `${months} ${months > 1 ? "Months" : "Month"}`
                : days
                ? `${days} ${days > 1 ? "Days" : "Day"}`
                : hours
                ? `${hours} ${hours > 1 ? "Hours" : "Hour"}`
                : minutes
                ? `${minutes} ${minutes > 1 ? "Minutes" : "Minute"}`
                : `${seconds} ${seconds > 1 ? "Seconds" : "Second"}`
        } ago`;
    };

    _renderEpisodeBlock = (episode, props) => (
        <div className="row" style={{ minHeight: props.episodeBlockMinHeight }}>
            {props.showStudentName || props.showCustomHead
                ? this.getDivision(
                      "episode-student-name col-xs-9 col-sm-9 col-md-9 col-lg-9",
                      props.showCustomHead || episode.name
                  )
                : null}
            {props.showProfileLink
                ? this.getDivision(
                      "col-xs-3 col-sm-3 col-md-3 col-lg-3 view-profile-link on-right",
                      <label
                          onClick={() => this.props.openStudentProfile(episode.student_id)}
                          style={{ cursor: "pointer" }}
                      >
                          {"View Profile"}
                      </label>
                  )
                : null}

            {props.showStudentDetails
                ?
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12"> 
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 hsg-episode-front-background"> 
                        {this.getDivision('col-xs-12 col-sm-6 col-md-3 col-lg-3', <label>{`Class: ${episode.class}`}</label>)}
                        {this.getDivision('col-xs-12 col-sm-6 col-md-3 col-lg-3', <label>{`Section: ${episode.section}`}</label>)}
                        {this.getDivision('col-xs-12 col-sm-6 col-md-3 col-lg-3', <label>{`DOB: ${moment(episode.dob).format(Constants.defaultDateFormat)}`}</label>)}
                        {this.getDivision('col-xs-12 col-sm-6 col-md-3 col-lg-3', <label>{`Gender: ${episode.gender ? episode.gender === 'M' ? 'MALE' : 'FEMALE' : ''}`}</label>)}
                        {this.getDivision('col-xs-12 col-sm-6 col-md-6 col-lg-6', <label>{`Admission Number: ${episode.admission_number}`}</label>)}
                        {this.props.roleTypeHandler !== 5 && Boolean(episode.episodes) && this.getDivision('col-xs-12 col-sm-6 col-md-3 col-lg-3', <label>{`Nurse Name: ${episode.episodes[0].nurse_name}`}</label>)}
                        {this.props.roleTypeHandler !== 5 && Boolean(episode.episodes) && Boolean(episode.episodes[0].med_spo_2) && this.getDivision('col-xs-12 col-sm-6 col-md-3 col-lg-3', <label>{`SPO2: ${episode.episodes[0].med_spo_2}`}</label>)}
                        {this.props.roleTypeHandler !== 5 && Boolean(episode.episodes) && Boolean(episode.episodes[0].med_in_time) && this.getDivision('col-xs-12 col-sm-6 col-md-3 col-lg-3', <label>{`Time In: ${episode.episodes[0].med_in_time}`}</label>)}
                        {this.props.roleTypeHandler !== 5 && Boolean(episode.episodes) && Boolean(episode.episodes[0].med_out_time) && this.getDivision('col-xs-12 col-sm-6 col-md-3 col-lg-3', <label>{`Time Out: ${episode.episodes[0].med_out_time}`}</label>)}
                        {/* {this.getDivision('col-xs-12 col-sm-6 col-md-6 col-lg-6', <label>{`HSG ID: ${episode.uuid}`}</label>)} */}
                    </div>
                </ div> 
                : null}
                {props.showEpisodeDate
                ? this.getDivision(
                      "episode-modified-time col-xs-12 col-sm-12 col-md-12 col-lg-12",
                      moment(episode.modified_time).format('DD MMM YYYY , HH:mm')

                  )
                : this.props.showTimePassed
                ? this.getDivision(
                      "episode-modified-time col-xs-12 col-sm-12 col-md-12 col-lg-12",
                      moment(episode.modified_time).format('DD MMM YYYY, HH:mm')
                    //   new Date(episode.modified_time).toLocaleDateString("en-US", DATE_OPTIONS)
                  )
                : null}
                { history.location.pathname !== "/infirmary" && episode.episodes && Boolean(episode.episodes[0].nurse_name) &&
                   <div className = "episode-modified-time col-xs-12 col-sm-12 col-md-12 col-lg-12">
                       <b>Nurse Name </b> : {episode.episodes[0].nurse_name}
                   </div>
                }
                 { history.location.pathname !== "/infirmary" && episode.episodes &&  Boolean(episode.episodes[0].med_in_time) &&
                   <div className = "episode-modified-time col-xs-12 col-sm-12 col-md-12 col-lg-12">
                       <b>Time In</b> : {episode.episodes[0].med_in_time}
                   </div>
                }
                 { history.location.pathname !== "/infirmary" && episode.episodes &&  Boolean(episode.episodes[0].med_out_time) &&
                   <div className = "episode-modified-time col-xs-12 col-sm-12 col-md-12 col-lg-12">
                       <b>Time Out </b> : {episode.episodes[0].med_out_time}
                   </div>
                }
            
            {episode.episodes &&
                episode.episodes.map((element, index) =>
                    this._renderStudentEpisodeInfoV2(
                        element && element.episode_custom_json,
                        props,
                        element.episode_type,
                        index
                    )
                )}
        </div>
    );

    _renderTimeLineBlock = (name, profile) => (
        <div className="row">
            <div className="hsg-dashboard-avatar-container">
                {/* <img src={avatarGirl} className="hsg-dashboard-avatar-image" /> */}
                {/* <p className="hsg-dashboard-avatar-name">{this.formatName(child.name)}</p>
                <div className="hsg-dashboard-primary-panel-button" onClick={this.props.onClickTalkToExpert}>
                    {BUTTON_CONTACT_EXPERT}
                </div> */}
                <Avatar name={name} src={profile} round="50px" />
            </div>
            <div className="verticle-line"></div>
        </div>
    );

    _renderEpisodeTimeLine = (episode, props) => (
        <Grid fluid>
            <Row className="show-grid">
                {
                    props.dim.width > SMALL_SWITCH ? 
                    <Col md={2} lg={2} sm={12} xs={12} style={{ padding: 0 }}>
                        {this._renderTimeLineBlock(episode.name, episode.json_value.profile_picture)}
                    </Col> : null    
                }   
                <Col md={10} lg={10} sm={12} xs={12} style={{ padding: 0 }}>
                    {this._renderEpisodeBlock(episode, props)}
                </Col>
            </Row>
        </Grid>
    );

    render() {
        let props = this.props;
        let { episode, index } = props;

        let views = {
            cardView: (
                <HSGCard hideHeader={true} key={index}>
                    {" "}
                    {this._renderEpisodeBlock(episode, props)}{" "}
                </HSGCard>
            ),
            plainView: <div key={index}> {this._renderEpisodeBlock(episode, props)} </div>,
            plainTimeLine: <div key={index}> {this._renderEpisodeTimeLine(episode, props)} </div>,
            cardTimeLine: (
                <HSGCard hideHeader={true} key={index}>
                    {" "}
                    {this._renderEpisodeTimeLine(episode, props)}{" "}
                </HSGCard>
            )
        };

        return views[props.episodeViewType || "cardView"];
    }
}

export default EpisodeCard;



// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainerV2/Component/Episode/EpisodeCard.js